export default function isExternalLink(url) {
  return url.includes('https://')
}
